import { useEffect } from 'react';

/**
 * Custom hook to lock/unlock body scroll while preserving scrollbar space
 * Prevents the "jump" effect when modals open/close
 * 
 * @param {boolean} isLocked - Whether to lock the scroll
 */
export const useScrollLock = (isLocked) => {
  useEffect(() => {
    if (isLocked) {
      // Calculate scrollbar width to preserve the space
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      // Store original values to restore later
      const originalOverflow = document.body.style.overflow;
      const originalPaddingRight = document.body.style.paddingRight;
      
      // Lock scroll and preserve scrollbar space
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      
      // Store original values on the body element for cleanup
      document.body.setAttribute('data-original-overflow', originalOverflow);
      document.body.setAttribute('data-original-padding-right', originalPaddingRight);
    } else {
      // Restore original values
      const originalOverflow = document.body.getAttribute('data-original-overflow') || '';
      const originalPaddingRight = document.body.getAttribute('data-original-padding-right') || '';
      
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
      
      // Clean up stored values
      document.body.removeAttribute('data-original-overflow');
      document.body.removeAttribute('data-original-padding-right');
    }

    // Cleanup on unmount - always restore scroll
    return () => {
      const originalOverflow = document.body.getAttribute('data-original-overflow') || '';
      const originalPaddingRight = document.body.getAttribute('data-original-padding-right') || '';
      
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
      
      // Clean up stored values
      document.body.removeAttribute('data-original-overflow');
      document.body.removeAttribute('data-original-padding-right');
    };
  }, [isLocked]);
};

export default useScrollLock;


